import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowRight, ChevronDown, Menu, X } from 'lucide-react';
import { services } from '../mock';

const links = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Services', to: '/services', dropdown: true },
  { label: 'Projects', to: '/projects' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Career', to: '/career' },
  { label: 'CSR', to: '/csr' },
  { label: 'Contact', to: '/contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`sticky top-0 z-50 bg-white transition-shadow ${scrolled ? 'shadow-md' : ''}`}>
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="shrink-0" aria-label="Indian Energreen home">
          <img
            src="/assets/indian-energreen-logo-transparent.png"
            alt="Indian Energreen - Renewable Energy Solutions"
            className="h-16 sm:h-20 w-auto object-contain"
          />
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <li key={l.label}
                className="relative"
                onMouseEnter={() => l.dropdown && setActiveDropdown(l.label)}
                onMouseLeave={() => setActiveDropdown(null)}>
              <NavLink to={l.to} end={l.to === '/'}
                 className={({ isActive }) => `flex items-center gap-1 px-4 py-2 text-[15px] font-semibold transition-colors ${isActive ? 'text-emerald-600' : 'text-slate-700 hover:text-emerald-600'}`}>
                {l.label}
                {l.dropdown && <ChevronDown className="w-4 h-4" />}
              </NavLink>
              {l.dropdown && activeDropdown === l.label && (
                <div className="absolute left-0 top-full pt-2 w-56 z-50">
                  <div className="bg-white rounded-xl shadow-xl border border-slate-100 py-2">
                    {services.map((s) => (
                      <Link key={s.id} to={`/services/${s.id}`}
                         className="block px-4 py-2.5 text-sm text-slate-700 hover:bg-emerald-50 hover:text-emerald-700 transition-colors">
                        {s.title}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>

        <Link to="/contact"
                className="hidden lg:inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white px-5 py-2.5 rounded-full font-semibold shadow-md shadow-emerald-200 hover:shadow-emerald-300 transition-all">
          Request Quote <ArrowRight className="w-4 h-4" />
        </Link>

        <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-slate-700">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white px-6 py-4">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)}
               className="block py-2.5 font-semibold text-slate-700 hover:text-emerald-600">{l.label}</Link>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} className="mt-3 block text-center w-full bg-emerald-500 text-white py-3 rounded-full font-semibold">Request Quote</Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
